import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, useTheme } from 'styled-components';
import {
    Body as CardBody,
    Header as CardHeader,
    Card as StyledCard,
    Title as CardTitle
} from './Component';
import { isScreenSize } from 'newJs/utils';
const CardContext = React.createContext();

/** Panel
 * @param {string} [skin=undefined|dark|light] skin color
*/
const Card = (props) => {
    // console.log(props);
    const {
        children,
        skin,
        autoOpen = true,
        // closeText = 'Close',
        hasCloseBtn = true,
        onClose = null,
        ...restProps
    } = props;
    const [isOpen, setIsOpen] = React.useState(autoOpen);
    const { breakpoint: bp, panel } = useTheme();

    const onPanelClose = React.useCallback(
        () => {
            setIsOpen(false);
            if (typeof onClose === 'function') onClose();
        },
        [onClose]
    );

    if (!isOpen) return null;

    const panelWidth = panel?.width ? panel.width : bp.list[bp.name] || 'auto';
    const theme = {
        panel: { ...panel, width: panelWidth }
    };
    const contextVal = {
        actions: { onPanelClose },
        params: { skin, hasCloseBtn, isSmallScreen: isScreenSize.small(bp.name) }
    };

    return (
        <ThemeProvider theme={theme}>
            <CardContext.Provider value={contextVal}>
                <StyledCard {...restProps}>{children}</StyledCard>
            </CardContext.Provider>
        </ThemeProvider>
    );
};

Card.propTypes = {
    autoOpen: PropTypes.bool,
    children: PropTypes.node,
    closeText: PropTypes.string,
    hasCloseBtn: PropTypes.bool,
    isSmallScreen: PropTypes.bool,
    onClose: PropTypes.func,
    skin: PropTypes.string
};

Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Body = CardBody;

export const useCardProps = () => {
    const context = React.useContext(CardContext);

    if (context === undefined) {
        throw new Error('useCardProps must be used within CardContext provider');
    }
    return context;
};

export default Card;
